export enum DeviceTabTypeEnum {
  Overview = "overview",
  Insights = "insights",
  AlertHistory = "alert-history",
  ActiveAlerts = "active-alerts",
  AlertSettings = "alert-settings",
  ReportedState = "reported-state",
  Rules = "rules",
}
